let ITrackingStatus = /*#__PURE__*/function (ITrackingStatus) {
  ITrackingStatus["READY_FOR_COLLECTION"] = "READY_FOR_COLLECTION";
  ITrackingStatus["READY_FOR_COLLECTION_01"] = "READY_FOR_COLLECTION_01";
  ITrackingStatus["READY_FOR_COLLECTION_INCIDENT"] = "READY_FOR_COLLECTION_INCIDENT";
  ITrackingStatus["READY_FOR_COLLECTION_INCIDENT_01"] = "READY_FOR_COLLECTION_INCIDENT_01";
  ITrackingStatus["READY_FOR_COLLECTION_INCIDENT_02"] = "READY_FOR_COLLECTION_INCIDENT_02";
  ITrackingStatus["READY_FOR_COLLECTION_INCIDENT_03"] = "READY_FOR_COLLECTION_INCIDENT_03";
  ITrackingStatus["IN_TRANSIT"] = "IN_TRANSIT";
  ITrackingStatus["IN_TRANSIT_01"] = "IN_TRANSIT_01";
  ITrackingStatus["IN_TRANSIT_02"] = "IN_TRANSIT_02";
  ITrackingStatus["IN_TRANSIT_03"] = "IN_TRANSIT_03";
  ITrackingStatus["IN_TRANSIT_04"] = "IN_TRANSIT_04";
  ITrackingStatus["IN_TRANSIT_05"] = "IN_TRANSIT_05";
  ITrackingStatus["IN_TRANSIT_06"] = "IN_TRANSIT_06";
  ITrackingStatus["IN_TRANSIT_07"] = "IN_TRANSIT_07";
  ITrackingStatus["IN_TRANSIT_100"] = "IN_TRANSIT_100";
  ITrackingStatus["IN_TRANSIT_INCIDENT"] = "IN_TRANSIT_INCIDENT";
  ITrackingStatus["IN_TRANSIT_INCIDENT_01"] = "IN_TRANSIT_INCIDENT_01";
  ITrackingStatus["IN_TRANSIT_INCIDENT_02"] = "IN_TRANSIT_INCIDENT_02";
  ITrackingStatus["IN_TRANSIT_INCIDENT_03"] = "IN_TRANSIT_INCIDENT_03";
  ITrackingStatus["IN_TRANSIT_INCIDENT_04"] = "IN_TRANSIT_INCIDENT_04";
  ITrackingStatus["IN_TRANSIT_INCIDENT_05"] = "IN_TRANSIT_INCIDENT_05";
  ITrackingStatus["IN_TRANSIT_INCIDENT_06"] = "IN_TRANSIT_INCIDENT_06";
  ITrackingStatus["IN_TRANSIT_INCIDENT_07"] = "IN_TRANSIT_INCIDENT_07";
  ITrackingStatus["IN_TRANSIT_INCIDENT_08"] = "IN_TRANSIT_INCIDENT_08";
  ITrackingStatus["IN_TRANSIT_INCIDENT_09"] = "IN_TRANSIT_INCIDENT_09";
  ITrackingStatus["IN_TRANSIT_INCIDENT_10"] = "IN_TRANSIT_INCIDENT_10";
  ITrackingStatus["IN_TRANSIT_INCIDENT_11"] = "IN_TRANSIT_INCIDENT_11";
  ITrackingStatus["IN_TRANSIT_INCIDENT_12"] = "IN_TRANSIT_INCIDENT_12";
  ITrackingStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  ITrackingStatus["OUT_FOR_DELIVERY_01"] = "OUT_FOR_DELIVERY_01";
  ITrackingStatus["OUT_FOR_DELIVERY_02"] = "OUT_FOR_DELIVERY_02";
  ITrackingStatus["OUT_FOR_DELIVERY_03"] = "OUT_FOR_DELIVERY_03";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT"] = "OUT_FOR_DELIVERY_INCIDENT";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_01"] = "OUT_FOR_DELIVERY_INCIDENT_01";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_02"] = "OUT_FOR_DELIVERY_INCIDENT_02";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_03"] = "OUT_FOR_DELIVERY_INCIDENT_03";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_04"] = "OUT_FOR_DELIVERY_INCIDENT_04";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_05"] = "OUT_FOR_DELIVERY_INCIDENT_05";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_06"] = "OUT_FOR_DELIVERY_INCIDENT_06";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_07"] = "OUT_FOR_DELIVERY_INCIDENT_07";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_08"] = "OUT_FOR_DELIVERY_INCIDENT_08";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_09"] = "OUT_FOR_DELIVERY_INCIDENT_09";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_10"] = "OUT_FOR_DELIVERY_INCIDENT_10";
  ITrackingStatus["OUT_FOR_DELIVERY_INCIDENT_11"] = "OUT_FOR_DELIVERY_INCIDENT_11";
  ITrackingStatus["DELIVERED"] = "DELIVERED";
  ITrackingStatus["DELIVERED_01"] = "DELIVERED_01";
  ITrackingStatus["DELIVERED_02"] = "DELIVERED_02";
  ITrackingStatus["DELIVERED_03"] = "DELIVERED_03";
  ITrackingStatus["DELIVERED_04"] = "DELIVERED_04";
  ITrackingStatus["DELIVERED_05"] = "DELIVERED_05";
  ITrackingStatus["DELIVERED_06"] = "DELIVERED_06";
  ITrackingStatus["DELIVERED_07"] = "DELIVERED_07";
  ITrackingStatus["RETURNED_TO_SENDER"] = "RETURNED_TO_SENDER";
  ITrackingStatus["EXCEPTION"] = "EXCEPTION";
  ITrackingStatus["EXCEPTION_01"] = "EXCEPTION_01";
  ITrackingStatus["EXCEPTION_02"] = "EXCEPTION_02";
  ITrackingStatus["EXCEPTION_03"] = "EXCEPTION_03";
  ITrackingStatus["EXCEPTION_04"] = "EXCEPTION_04";
  ITrackingStatus["UNKNOWN"] = "UNKNOWN";
  return ITrackingStatus;
}({});

export { ITrackingStatus };
//# sourceMappingURL=TrackingStatus.js.map
